//import { routerReducer } from '@ngrx/router-store';
import { MetaReducer } from '@ngrx/store';
import * as fromApp from '../app/app.reducer';
import { Root } from './root.state';

// import * as fromSettingsUsers from '../settings/users/users.reducer';
// import * as fromSettingsGroups from '../settings/groups/groups.reducer';
// import * as fromSettingsLicenses from '../settings/licenses/licenses.reducer';
// import * as fromSettingsRules from '../settings/rules/rules.reducer';

import * as fromSettingsReducer from '../settings/settings.reducers';
import * as fromProjectsReducer from '../projects/projects.reducer';
import * as fromProjectsFormsReducer from '../projects/custom-forms/projects-custom-forms.reducer';
import * as fromLabelsReducer from '../labels/labels.reducer';
import * as fromVersionsReducer from '../versions/versions.reducer';
import * as fromAddProjectReducer from '../add-project/add-project.reducer';
import * as fromAddVersionReducer from '../add-version/add-version.reducer';
import * as fromLibraryReducer from '../library/library.reducer';
import * as fromDasboardReducer from '../dashboard/dashboard.reducer';
import * as fromApprovalsReducer from '../approvals/approvals.reducer';
import * as fromUsersOnlineReducer from '../users-online/users-online.reducer';
import * as fromAIReducer from '../ai/ai.reducer';

// form Core
import * as fromNotificationsReducer from '@core/store/state/notifications/notifications.reducer';
import * as fromRecorderReducer from '@core/store/state/recorder/recorder.reducer';
import * as fromCustomFormsReducer from '@core/store/state/custom-forms/custom-forms.reducer';

export const rootReducers = {
    app: fromApp.appReducer,
    settings: fromSettingsReducer.settingsReducer,
    projects: fromProjectsReducer.projectsReducer,
    projects_forms: fromProjectsFormsReducer.projectsCustomFormsReducer,
    versions: fromVersionsReducer.versionsReducer,
    labels: fromLabelsReducer.labelsReducer,
    new_project: fromAddProjectReducer.addProjectReducer,
    new_version: fromAddVersionReducer.addVersionReducer,
    library: fromLibraryReducer.libraryReducer,
    dashboard: fromDasboardReducer.dashboardReducer,
    approvals: fromApprovalsReducer.approvalsReducer,
    ai: fromAIReducer.aiReducer,
    notifications: fromNotificationsReducer.notificationsReducer,
    recorder: fromRecorderReducer.recorderReducer,
    custom_forms: fromCustomFormsReducer.customFormsReducer,
    users_online: fromUsersOnlineReducer.usersOnlineReducer
};

export const metaReducers: MetaReducer<Root>[] = [];
